define('OutSystems/ClientRuntime/modules/Database/EntityInfoUtils',["require", "exports", "../../Exceptions", "../../RegExpHelper"], function (require, exports, Exceptions_1, RegExpHelper) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getDynamicSortList = void 0;
    function getEntityNameFromMatch(m) {
        if (m.value.charAt(m.value.length - 1) === ".") {
            return m.value.substr(0, m.value.length - 1);
        }
        else {
            return m.value.substr(1, m.value.length - 2);
        }
    }
    function replaceEntityNameInOrderBy(m, entityNames) {
        var entityName = getEntityNameFromMatch(m);
        var result = entityNames.some(function (currEntity) { return currEntity.toLowerCase() === entityName.toLowerCase(); })
            ? entityName
            : "";
        if (result === "") {
            throw new Exceptions_1.Exceptions.DataBaseException("", "'" + entityName + "' found in 'Order By' parameter is an invalid Entity");
        }
        if (m.value.charAt(m.value.length - 1) === ".") {
            return result + ".";
        }
        else {
            return result;
        }
    }
    function getDynamicSortList(paramValue, entityNames) {
        var ret = null;
        var cleanValue = paramValue.trim();
        if (cleanValue !== "") {
            var matches = RegExpHelper.matches(cleanValue, "((((\\{\\w+\\})|(\\w+)).)?((\\[\\w+\\])|(\\w+))(( )+(desc|asc))?)(( )*,( )*(((\\{\\w+\\})|(\\w+)).)?((\\[\\w+\\])|(\\w+))(( )+(desc|asc))?)*", true);
            if (matches.length !== 1 || matches[0].value !== cleanValue) {
                throw new Exceptions_1.Exceptions.DataBaseException("", "Invalid syntax in 'Order By' parameter.");
            }
        }
        else {
            return [];
        }
        var meReplaceEntityName = function (match) {
            return replaceEntityNameInOrderBy(match, entityNames);
        };
        var meReplaceAttributeName = function (match) {
            return match.value.substr(1, match.value.length - 2);
        };
        ret = RegExpHelper.replace(cleanValue, "(\\{\\w+\\}|\\w+\\.)", false, meReplaceEntityName);
        ret = RegExpHelper.replace(ret, "(\\[\\w+\\])", false, meReplaceAttributeName);
        var sortsList = ret.split(/, ?/);
        return sortsList.map(function (sort) {
            var parts = sort.trim().split(" ");
            var ascending = parts.length === 2 ? parts[1].toLowerCase() === "asc" : true;
            var attrParts = parts[0].split(".");
            return {
                attributeParts: attrParts,
                isAscending: ascending,
            };
        });
    }
    exports.getDynamicSortList = getDynamicSortList;
});
//# sourceMappingURL=EntityInfoUtils.js.map;
